<template>

  <div>
    <Head title="Posts" />
    <h1 class="mb-8 text-3xl font-bold">Posts</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Instagram Accounts:</label>
        <select placeholder="Choose Account" v-model="form.account" class="form-select mt-1 w-full">
          <option  key="ALL" value="ALL"> Choose Brands </option>
            <option v-for="account in insta_account" :key="account.insta_account_id" :value="account.insta_account_id">
              {{ account.name + ' ('+account.content_models_count +')'}}
              </option>
        </select>
      </search-filter>

      <!-- Content Owner -->
      <div class="flex items-center space-x-4">
        <div>
          <label for="content_owner" class="block text-sm font-medium text-gray-700">
            Content Owner
          </label>
          <!-- <input
            type="date"
            id="content_owner"
            v-model="form.content_owner"
            class="form-input mt-1 block w-full border-gray-300 rounded-md shadow-sm"
          /> -->
             <select placeholder="Choose Owner" v-model="form.content_owner" class="form-select mt-1 w-full">
                <option  key="ALL" value="ALL"> Choose Owner </option>
                <option value="US">US</option>
                <option value="THEM">Them</option>
                <option value="BOTH">COLLAB</option>
              </select>
            </div>
        </div>


       <!-- Date Filters -->
       <div class="flex items-center space-x-4">
        <div>
          <label for="from_date" class="block text-sm font-medium text-gray-700">
            From Date
          </label>
          <input
            type="date"
            id="from_date"
            v-model="form.from_date"
            class="form-input mt-1 block w-full border-gray-300 rounded-md shadow-sm"
             @change="validateDateRange"
          />
        </div>

        <!-- To Date -->
        <div>
          <label for="to_date" class="block text-sm font-medium text-gray-700">
            To Date 
           <span v-if="dateError" class="text-red-500 mt-2">{{ dateError }}</span>

          </label>
          <input
            type="date"
            id="to_date"
            v-model="form.to_date"
            class="form-input mt-1 block w-full border-gray-300 rounded-md shadow-sm"
             @change="validateDateRange"
          />
        </div>
      </div>
         <!-- <select v-model="form.content_type" class="form-select mt-1 w-full">
            <option value="Product Promotion">Product Promotion</option>
            <option value="Offer">Offer</option>
            <option value="Review">Review</option>
            <option value="Tutorial">Tutorial</option>
            <option value="Entertainment">Entertainment</option>
        </select>  -->
      <!-- <Link class="btn-indigo" href="/post/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;post</span>
      </Link> -->

  <Link
    class="btn-indigo relative flex items-center justify-center"
    href="/post/getcontent"
    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
    :disabled="isDisabled"
    @click="handleClick"
  >
    <span v-if="!isLoading">
      <span></span>
      <span class="hidden md:inline">&nbsp;Pull New Posts</span>
    </span>
    <span v-else>
      <svg
        class="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </span>
  </Link>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Short Code</th>
          <th class="pb-4 pt-6 px-6">Brand</th>
          <th class="pb-4 pt-6 px-6">Sale Amount</th>
          <th class="pb-4 pt-6 px-6">Platform <br>price</th>
          <!-- <th class="pb-4 pt-6 px-6">Market Price</th>
          <th class="pb-4 pt-6 px-6">Deal price</th> -->
          <th class="pb-4 pt-6 px-6">Influencer <br>Charges</th>
          <th class="pb-4 pt-6 px-6">Platform<br> Charges</th>
          <th class="pb-4 pt-6 px-6">Posted <br> Date</th>
          <!-- <th class="pb-4 pt-6 px-6">Total Views</th> -->
          <th class="pb-4 pt-6 px-6">Reach</th>
          <th class="pb-4 pt-6 px-6">Likes</th>
          <th class="pb-4 pt-6 px-6">Shares</th>
          <th class="pb-4 pt-6 px-6">Comment</th>
          <th class="pb-4 pt-6 px-6">Saved</th>
        </tr> 
        <tr v-for="(content) in content.data" :key="content.cntnt_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- S.No column -->
            
          <td class="border-t px-6 py-4">
            <div class="flex items-center space-x-4 px-6 py-4">
              <template v-if="content.media && content.media.shortcode">
                <a :href="content.cntnt_url" target="_blank" class="highlight-link hover:underline">
                  {{ content.cntnt_shortcode }}
                </a>
              </template>
              <template v-else>
                <span>{{ content.cntnt_shortcode }}</span>
              </template>
              <a 
                v-if="content.cntnt_is_prod" 
                class="flex items-center text-sm text-gray-600 hover:text-blue-600"
                title="Add pricing details for products"
                :href="`/post/${content.cntnt_id}/buyeredit`"
                style="color: green;"
              >Add price
                <!-- Pencil Icon -->
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  class="h-4 w-4 mr-1" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor" 
                  stroke-width="2"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" 
                    d="M11 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-5m-5.586-9.586a2 2 0 112.828 2.828L11 14l-4 1 1-4 6.414-6.414z" />
                </svg>
                
              </a>
             
            </div>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
              <b>  {{ content.account.name }} </b> 
            </Link>
        </td>
      <td  class="border-t"> 
          <span v-if="content.sales" >
            <button @click="openPopup(content)" class="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600">
              {{JSON.parse(content.sales.sale_meta_data).saleNetAmount }}
              <i class="fas fa-eye"></i> 👁️
            </button> 
          </span>
          <span v-else class="flex items-center px-6 py-4" >
            {{'N/A' }}
          </span>
        </td>
        
    
    <!-- <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            {{ content.cntnt_market_price }}
        </Link>
    </td> -->

    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            {{ content.cntnt_platform_price }}
        </Link>
    </td>
    <!-- <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            {{ content.cntnt_deal_price }}
        </Link>
    </td> -->
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            {{ content.cntnt_crtr_charges }}
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            {{ content.cntnt_platform_charges }}
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            <span v-if="content.cntnt_posted_date && content.cntnt_posted_date" >  {{formatDate(content.cntnt_posted_date) }} </span>
            <span v-else>N/A</span> 
        </Link>
    </td>
    <!-- <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            <span v-if=" content.metrics && content.metrics.mt_total_play_count" >  {{content.metrics.mt_total_play_count }} </span>
            <span v-else>N/A</span>
        </Link>
    </td> -->
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            <span v-if=" content.metrics && content.metrics.mt_views" >  {{content.metrics.mt_views }} </span>
            <span v-else>N/A</span>
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            <span v-if=" content.metrics && content.metrics.mt_likes" >  {{content.metrics.mt_likes }} </span>
            <span v-else>N/A</span>
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
              <span v-if=" content.metrics && content.metrics.mt_shares" >  {{content.metrics.mt_shares }} </span>
            <span v-else>N/A</span>
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
           <span v-if=" content.metrics && content.metrics.mt_comments" >  {{content.metrics.mt_comments }} </span>
          <span v-else>N/A</span>
        </Link>
    </td>
    <td class="border-t">
        <Link class="flex items-center px-6 py-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
            <span v-if=" content.metrics && content.metrics.mt_saves" >  {{content.metrics.mt_saves }} </span>
            <span v-else>N/A</span>
        </Link>
    </td>

          <!-- Post Content Name -->
          <!-- <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/content/${content.cntnt_id}/edit`" tabindex="-1">
                  {{ content.crtr_name }}
              </Link>
          </td> -->

          <!-- Is Influencer -->
          <!-- <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/content/${content.cntnt_id}/edit`" tabindex="-1">
                {{ content.crtr_is_influencer === 1 ? 'Yes' : 'No' }}
              </Link>
          </td> -->

          <!-- Action Icon -->
          <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
          </td>
      </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="content.links" />
     <!-- Popup Modal -->
  <!-- Popup Modal -->
  <div v-if="showPopup" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
  <div class="bg-white w-1/2 rounded-lg shadow-lg p-6 relative">
    <!-- Close Button -->
    <button 
      @click="closePopup" 
      class="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
      aria-label="Close"
    >
      &times;
    </button>
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Sales Data</h3>
        <!-- {{ this.saleDataMeta.dayWiseSales }} -->

        <div v-if="modalData.sales && saleDataMeta">
           <!-- Display Remaining Data as Labels in H1 -->
            <h1>Sale Net Amount: {{ saleDataMeta.saleNetAmount }}</h1>
            <h1>Sale Quantity: {{ saleDataMeta.saleQty }}</h1>
            <h1>Total Bills Amount: {{ saleDataMeta.SaleTotalBillsAmount }}</h1>
            <h1>Total Bills Quantity: {{ saleDataMeta.saleTotalBillsQty }}</h1>

            <!-- Display dayWiseSales Data in Table -->
            <table class="table-auto border-collapse border border-gray-300 w-full mt-4">
              <thead>
                <tr class="bg-gray-200">
                  <th class="border border-gray-300 px-4 py-2">Sale Date</th>
                  <th class="border border-gray-300 px-4 py-2">Daily Sale Net Amount</th>
                  <th class="border border-gray-300 px-4 py-2">Daily Sale Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(daySale, index) in saleDataMeta.dayWiseSales" 
                  :key="index" 
                  class="hover:bg-gray-100 focus-within:bg-gray-100"
                >
                  <td class="border border-gray-300 px-4 py-2">{{ daySale.SALE_DATE }}</td>
                  <td class="border border-gray-300 px-4 py-2">{{ daySale.dailySaleNetAmount }}</td>
                  <td class="border border-gray-300 px-4 py-2">{{ daySale.dailySaleQty }}</td>
                </tr>
              </tbody>
            </table>
        </div>
     

        <div class="mt-4 flex justify-end">
          <button 
            @click="closePopup" 
            class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import axios from 'axios';

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    TextInput
  },
  layout: Layout,
  props: {
    filters:{
      type: Object,
      default: () => ({})
    },
    content: Object,
    insta_account: Array
  },
  data() {
    // console.log(this.filters.from_date);
    
    return {
      form: {
        search: this.filters['search'] || '',
        content_type: this.filters['content_type'] ||'',
        account: this.filters['account'] || 'ALL',
        from_date: this.filters['from_date'] || '',
        to_date: this.filters['to_date'] || '', 
        content_owner: this.filters['content_owner'] || '', 
      },
      isDisabled: false,
      isLoading: false,
      showPopup : false,
      modalData :'',
      saleDataMeta :'',
      dateError: '',

    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        console.log('in handler');
        this.$inertia.get('/post', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    validateDateRange() {
      if (this.form.from_date && this.form.to_date) {
        const fromDate = new Date(this.form.from_date);
        const toDate = new Date(this.form.to_date);

        if (fromDate > toDate) {
          this.dateError = 'From Date cannot be greater than To Date.';
        } else {
          this.dateError = ''; // Clear error if valid
        }
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
       // Call the backend route to reset the session filters
      axios.get('post/reset-filters')
      .then(response => {
        console.log(response.data.message); // 'Filters have been reset'
        // Additional actions can be performed here
      })
      .catch(error => {
        console.error('There was an error resetting the filters:', error);
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    openPopup(content) {
      this.showPopup = true;
      this.modalData = content; // Bind the sales data
      this.saleDataMeta = JSON.parse( content.sales.sale_meta_data || '{}');

    },
    closePopup(){
      this.showPopup = false;
      this.modalData  = '';
      this.saleDataMeta ={};
    },
    handleClick(event) {
      if (this.isDisabled) {
        event.preventDefault();
        return;
      }
      this.isDisabled = true;
      this.isLoading = true;

      // Simulate a network request or perform an action
      this.fetchPosts().finally(() => {
        this.isDisabled = false;
        this.isLoading = false;
      });
    },
    async fetchPosts() {
      // Simulate a network request or actual fetch logic
      try {
        console.log('Fetching posts...');
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulated delay
        console.log('Posts fetched successfully.');
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    },
   
  },
} 
</script>
<style scoped>
.highlight-link {
  color: #1D4ED8; /* Blue color */
  padding: 0.5rem 1.5rem;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: all 0.3s ease;
}

.highlight-link:hover {
  color: #1E40AF; /* Darker blue */
  background-color: #BFDBFE; /* Light blue background on hover */
}

/* Optional styles for disabled button */
.opacity-50 {
  opacity: 0.5;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
</style>